<template>
    <div class="main">
        <div class="container mx-auto text-center px-4 pb-16">
            <p class="pb-4">
                {{ $t('DASHBOARD_HI') }} {{ firstName }},
            </p>
            <p class="pb-6" v-text="$t('RESTART_PAGE_IF_YOU_D_LIKE')"></p>
            <div class="md:w-1/2 lg:w-1/4 sm:w-1/2 mx-auto">
                <h4 class="">
                    <a class="link"
                       v-show="!showCouponCode"
                       v-text="$t('COUPON_FIELD_ADD_OFFER')"
                       @click.prevent="showCouponCode = !showCouponCode"/>
                </h4>

                <restart-account-coupon-field
                    class="-mt-2"
                    v-if="showCouponCode"
                    :is-valid="!errorHandler.has('coupon_code')"
                    :message="$t(errorHandler.get('coupon_code'))"
                    v-model="couponCode"/>
                <div class="pt-4">
                    <button class="btn btn--full-width btn--primary btn--hoverable"
                            @click="restartSubscription(inactiveId[0], couponCode)"
                            :disabled="buttonDisabled"
                            v-text="$t('RESTART_PAGE_RESTART_DELIVERIES')">
                    </button>
                </div>

            </div>
        </div>
        <div v-if="isGiftingEnabled" class="background--paper p-1 divider--container">
            <div class="divider-white--top"></div>
            <div class="container mx-auto flex items-center justify-center px-2 pt-10 pb-4">
                <div class="w-full md:w-1/2 text-center">
                    <img src="@/assets/images/user-menu/gift.svg" alt="" class="inline-block w-16 h-16 mb-4">
                    <p v-text="$t('RESTART_PAGE_YOU_MIGHT')"></p>
                    <p v-text="$t('RESTART_PAGE_YOU_CAN')"></p>
                    <div class="sm:w-1/2 mx-auto px-4 pt-4 pb-8">
                        <router-link :to="{ name: 'account.gifting' }"
                                     tag="button"
                                     v-text="$t('RESTART_PAGE_SEND_A_GIFT')"
                                     class="btn btn--full-width btn--primary btn--hoverable">
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import SubscriptionService from '@/services/subscriptions/SubscriptionService';
import RestartAccountCouponField from '@/components/forms/fields/RestartAccountCouponField';

export default {
    name: 'RestartAccount',
    data() {
        return {
            buttonDisabled: false,
            errors: null,
            couponCode: null,
            showCouponCode: false,
            errorHandler: new ErrorResponseHandler(),
        };
    },
    computed: {
        firstName() {
            return this.$store.getters['account/getFirstName'];
        },
        inactiveId() {
            let arr = [];
            const inactiveSubscriptions = this.$store.getters['subscription/getInactiveSubscriptions'];
            let result = inactiveSubscriptions.map(function(e) {
                return e.id;
            });

            for (let i = 0; i < result.length; i++) {
                arr.push(result[i]);
            };

            return arr;
        },
        isGiftingEnabled() {
            return process.env.VUE_APP_GIFTING_ENABLED === 'true';
        },
    },
    mounted() {
        this.$store.dispatch('subscription/fetchAllSubscriptions', true);
    },
    methods: {
        /**
         * Restart user subscription.
         *
         * @param subscriptionId
         * @param couponCode
         *
         * @returns {Promise}
         */
        restartSubscription(subscriptionId, couponCode) {
            this.buttonDisabled = true;
            let service = new SubscriptionService();

            service.createSubscriptionFromLapsedSubscription({
                subscription_id: subscriptionId,
                coupon_code: couponCode,
            })
                .then(() => {
                    this.$store.dispatch('subscription/fetchAllSubscriptions', true);
                    this.$store.dispatch('address/fetchAllAddresses', true);
                    setTimeout(() => {
                        this.$router.push({ name: 'account.restart-confirmation-page' });
                    }, 200);
                })
                .catch(error => {
                    setTimeout(() => this.errorHandler.setResponse(error.response && error.response.data), 0);
                    this.buttonDisabled = false;
                });
        },
    },
    components: {
        RestartAccountCouponField,
    },
};
</script>
